module.exports = __webpack_public_path__ + "static/media/interface_engineer_logo_2022.01ef445a.jpg";